import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useWorkflowExecutionsRealtime = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    console.log("[useWorkflowExecutionsRealtime] Setting up realtime subscription");

    const channel = supabase
      .channel("workflow-executions-realtime")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "workflow_executions",
        },
        (payload) => {
          console.log("[useWorkflowExecutionsRealtime] Change detected:", payload.eventType);

          // Invalidate queries to refresh data
          queryClient.invalidateQueries({ queryKey: ["workflow-executions"] });
          queryClient.invalidateQueries({ queryKey: ["active-executions"] });
          queryClient.invalidateQueries({ queryKey: ["execution-metrics"] });

          // Show toast for status changes
          if (payload.eventType === "UPDATE" && payload.new) {
            const newData = payload.new as { status?: string; workflow_id?: string };
            const oldData = payload.old as { status?: string } | null;

            if (oldData && newData.status !== oldData.status) {
              if (newData.status === "success") {
                toast.success("Workflow succesvol afgerond", {
                  description: `Execution voltooid`,
                });
              } else if (newData.status === "failed") {
                toast.error("Workflow gefaald", {
                  description: `Execution mislukt`,
                });
              }
            }
          }

          // Refresh specific execution if being viewed
          if (payload.new && "id" in payload.new) {
            queryClient.invalidateQueries({ 
              queryKey: ["workflow-execution", payload.new.id] 
            });
          }
        }
      )
      .subscribe();

    return () => {
      console.log("[useWorkflowExecutionsRealtime] Cleaning up subscription");
      supabase.removeChannel(channel);
    };
  }, [queryClient]);
};
